export const selectShoppingList = s => s.lists.lists
export const selectShoppingListData = s => s.lists.data
export const selectShoppingListProducts = s => s.lists.products
